module.exports = __webpack_public_path__ + "static/media/Laundry.7acf029a.jpg";